module.exports = __webpack_public_path__ + "img/gro.56e67d68.jpg";